import React from 'react';

import {Form, FormikProps} from 'formik';
import {FileWithPath} from 'react-dropzone';
import {CallMade} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';
import {Box, Grid, Typography} from '@material-ui/core';

import {EfeAccordionValues} from 'commons';
import {InferPropTypes} from 'commons/types/Types';
import {HistoryRoutes, ViewKeys} from 'commons/constants';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';
import {EfeAccordion, EfeButtonPrimary, EfeErrorMsg} from 'components';
import {TaxIdValues} from 'commons/models/modules/content/TaxIdValues';
import EfeDragAndDrop from 'components/efe-drag-and-drop/EfeDragAndDrop';
import {ReactComponent as ActionIcon} from 'assets/icons/section/action/edit.svg';

InnerFormTaxId.propTypes = {};

function InnerFormTaxId(
    props: InferPropTypes<typeof InnerFormTaxId.propTypes & FormikProps<TaxIdValues>>
) {
    const history = useHistory();
    const {flow} = useFlowContext();
    const {setFieldValue, values, errors, isSubmitting} = props;
    const [uploadedFiles, setUploadedFiles] = React.useState<Array<FileWithPath>>([]);

    React.useEffect(() => {
        if (values && values.file) {
            try {
                const file = new File([values.file], 'Constancia de situaci\u00F3n Fiscal');
                const filePath = {...file};
                filePath.size = file.size;
                filePath.name = file.name;
                setUploadedFiles([filePath]);
            } catch (error) {
                console.error(error);
            }
        }
    }, [values]);

    const accordion: Array<EfeAccordionValues> = [
        {
            title: 'Constancia de situaci\u00F3n Fiscal',
            icon: <ActionIcon />,
            reactElement: (
                <Box m={2}>
                    <Form noValidate>
                        <Box mt={4} mb={4}>
                            <Typography variant='body2' color='textPrimary'>
                                {'Sube la constancia de situaci\u00F3n fiscal emitida por el SAT'}
                            </Typography>
                        </Box>
                        <EfeDragAndDrop
                            maxSizeFile={10}
                            numFiles={1}
                            file={values.file}
                            fileList={uploadedFiles}
                            deleteFile={deleteFile}
                            loadFile={uploadFile}
                        />
                        {errors.file && <EfeErrorMsg message={errors.file} />}
                        <Grid container direction='row' justifyContent='flex-end'>
                            <Box width={160} pt={6} m={2}>
                                <EfeButtonPrimary
                                    fullWidth
                                    disabled={isSubmitting}
                                    type='submit'
                                    endIcon={<CallMade />}>
                                    {'OK'}
                                </EfeButtonPrimary>
                            </Box>
                        </Grid>
                    </Form>
                </Box>
            ),
            disabled: false,
            expandIcon: true,
            expanded: ViewKeys.DATA_DOCUMENTATION_TAX_ID === flow.data.expandKey,
        },
    ];

    function uploadFile(file: FileWithPath) {
        if (file) {
            setUploadedFiles([file]);
            const reader = new FileReader();
            reader.onload = () => {
                setFile(reader.result ? reader.result : '');
            };
            reader.readAsDataURL(file);
        }
    }

    function deleteFile(index: number) {
        if (uploadedFiles && uploadedFiles.length) {
            uploadedFiles.splice(index, 1);
            const aux = [...uploadedFiles];
            setUploadedFiles(aux);
            setFieldValue('file', '');
        }
    }

    function setFile(file: string | ArrayBuffer) {
        setFieldValue('file', file);
    }

    return <EfeAccordion onChange={() => history.push(HistoryRoutes.TAX_ID)} values={accordion} />;
}

export default InnerFormTaxId;
